// extracted by mini-css-extract-plugin
module.exports = {"project-type-wall":"project-type-wall","icon":"icon","fold":"fold","project-type-card":"project-type-card"};